// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Malawi */
const MW = /^(?:111\d{6}|(?:2[12]|31|77|[89][89])\d{7})$/;

export default MW;
